export enum FeatureToggle {
  connectedStores = 'rt_connected_stores',
  caperTransactions = 'rt_connected_stores_caper_transactions',
  notOnFile = 'rt_connected_stores_caper_not_on_file',
}
